import { Controller } from 'stimulus'
import { createEmbed } from '~/common/helpers/embed'

export default class extends Controller {
  static targets = ['input', 'saveBtn', 'loader', 'dropdown']

  static values = {
    objectName: String,
  }

  closeDropdown = () => {
    this.dropdownTarget.dispatchEvent(new Event('dropdown:close'))
  }

  onCancelBtnClick = () => {
    this.closeDropdown()
  }

  onLinkBtnClick = () => {
    if (this.inputTarget.value.replace(/\s/g, '') === '') {
      window.showNotice('alert', 'Please enter a link')
      this.inputTarget.value = ''
      this.inputTarget.focus()
      return
    }
    this.showLoader()
    const form = this.element.closest('form.js-dropzone-form')

    createEmbed(this.inputTarget.value, this.objectNameValue, form)
      .then(() => {
        this.hideLoader()
        this.inputTarget.value = ''
        this.closeDropdown()
      })
      .catch((error) => {
        this.hideLoader()
        this.inputTarget.focus()
        window.showNotice('alert', error.message || String(error))
      })
  }

  showLoader = () => {
    this.saveBtnTarget.classList.add('hidden')
    this.loaderTarget.classList.remove('hidden')
  }

  hideLoader = () => {
    this.loaderTarget.classList.add('hidden')
    this.saveBtnTarget.classList.remove('hidden')
  }
}
